package com.hyperether.goodjob.scenes.components

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp
import com.hyperether.goodjob.models.User
import com.hyperether.goodjob.util.toScaleDp

@Composable
fun CircleWithInitialUser(user: User?, size: Dp = 32.toScaleDp(), modifier: Modifier = Modifier) {
    val initial = user?.getName().orEmpty()
    CircleWithInitial(initial, size, modifier)
}
